import { render, staticRenderFns } from "./menuBusinessActions.vue?vue&type=template&id=3768a26d&"
import script from "./menuBusinessActions.vue?vue&type=script&lang=js&"
export * from "./menuBusinessActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports